'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _TripDetail = require('./TripDetail.scss');

var _TripDetail2 = _interopRequireDefault(_TripDetail);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _trip = require('redux/modules/trip');

var tripDetailAction = _interopRequireWildcard(_trip);

var _search = require('redux/modules/search');

var _redirect = require('redux/modules/redirect');

var _Main = require('components/TripDetail/Main');

var _Main2 = _interopRequireDefault(_Main);

var _Product = require('components/StructuredData/Product');

var _Product2 = _interopRequireDefault(_Product);

var _Gallery = require('components/General/Gallery/Gallery');

var _Gallery2 = _interopRequireDefault(_Gallery);

var _Modal = require('components/General/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _ShareSocialsModal = require('components/TripDetail/ShareSocialsModal');

var _ShareSocialsModal2 = _interopRequireDefault(_ShareSocialsModal);

var _customize = require('redux/modules/customize');

var _media = require('utils/media');

var _initialLoadSuccess = require('redux/modules/initialLoadSuccess');

var _gallery = require('redux/modules/gallery');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  TripDetail: {
    displayName: 'TripDetail'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/containers/TripDetail/TripDetail.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Scroll from 'react-scroll';
// const Element = Scroll.Element;

_momentTimezone2.default.tz.setDefault('Asia/Bangkok');

var TripDetail = _wrapComponent('TripDetail')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch,
        slug = _ref.params.slug;

    return dispatch((0, _trip.load)(slug)).then(function (res) {
      if (res.is_redirect && res.slug) {
        return dispatch((0, _redirect.setRedirectedPath)('/trip/' + res.slug));
      }
      if (res.is_redirect && res.location) {
        return dispatch((0, _redirect.setRedirectedPath)('/to/' + res.location, 302));
      }
      return dispatch((0, _search.setLastTripId)(res._id));
    }).catch(function () {
      return dispatch((0, _initialLoadSuccess.loadFailed)());
    });
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    trip: state.trip.data,
    isOpenShare: state.trip.openShare,
    peerReview: state.routing.locationBeforeTransitions.query.peerReview === 'true'
  };
}, (0, _extends3.default)({}, tripDetailAction, { openGallery: _gallery.openGallery, logCustomizeTrip: _customize.logCustomizeTrip })), _dec3 = (0, _reactCssModules2.default)(_TripDetail2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TripDetail, _Component);

  function TripDetail(props) {
    (0, _classCallCheck3.default)(this, TripDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TripDetail.__proto__ || (0, _getPrototypeOf2.default)(TripDetail)).call(this, props));

    _this.closeShare = _this.closeShare.bind(_this);
    // this.handleScroll = this.handleScroll.bind(this);
    // this.state = {
    //   hideMobileAction: false,
    // };

    if (!(typeof _this.closeShare === 'function')) {
      throw new TypeError('Value of "this.closeShare" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.closeShare));
    }

    return _this;
  }

  (0, _createClass3.default)(TripDetail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.peerReview) this.props.loadPeerReview(this.props.trip.slug);
      if (window.hj) window.hj('tagRecording', ['trip-detail']);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.openShare(false);
      this.props.openGallery(false);
      this.props.openChat(false);
      // if (this.props.peerReview) window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'closeShare',
    value: function closeShare() {
      this.props.openShare(false);
    }

    // handleScroll() {
    //   if (this.props.peerReview && this.refs.peerReview) {
    //     const rect = this.refs.peerReview.getBoundingClientRect();
    //     const elemCenter = (rect.top + rect.bottom * 2) / 3;
    //     if (elemCenter <= window.innerHeight && rect.bottom >= 60) {
    //       this.setState({ hideMobileAction: true });
    //     } else {
    //       this.setState({ hideMobileAction: false });
    //     }
    //   }
    // }

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          trip = _props.trip,
          peerReview = _props.peerReview;

      return _react3.default.createElement(
        'div',
        { styleName: 'main-container' },
        _react3.default.createElement(_reactHelmet2.default, {
          title: trip.title || trip.name,
          meta: [{ 'property': 'og:image', 'content': (0, _media.path)(trip.cover_image) }, { 'property': 'og:description', 'content': trip.meta_description || trip.introduction }, { 'property': 'og:site_name', 'content': 'TakeMeTour - ' + (trip.title || trip.name) }, { 'property': 'description', 'content': trip.meta_description || trip.introduction }, { 'property': 'keywords', 'content': trip.keywords || [trip.destination_location].concat((0, _toConsumableArray3.default)(trip.activities)).join(',') }]
        }),
        _react3.default.createElement(_Product2.default, { name: trip.name, ratingValue: trip.user_id.rating.average_rating, reviewCount: trip.reviews.length, price: trip.full_prices[1] ? trip.full_prices[1].perPerson : trip.full_prices[0].perPerson }),
        _react3.default.createElement(_Main2.default, { peerReview: peerReview }),
        _react3.default.createElement(_Gallery2.default, { defaultAlt: trip.name, images: trip.images, video: trip.video_url }),
        _react3.default.createElement(
          _Modal2.default,
          { isOpen: this.props.isOpenShare, onClose: this.closeShare, centerVertical: true, style: { 'maxWidth': '600px', 'padding': '0', 'margin': '0 auto' }, id: 'trip-share' },
          _react3.default.createElement(_ShareSocialsModal2.default, { slug: trip.slug })
        )
      );
    }
  }]);
  return TripDetail;
}(_react2.Component), _class2.propTypes = {
  peerReview: _react2.PropTypes.bool,
  trip: _react2.PropTypes.object,
  openShare: _react2.PropTypes.func,
  isOpenShare: _react2.PropTypes.bool,
  openGallery: _react2.PropTypes.func,
  openChat: _react2.PropTypes.func,
  loadPeerReview: _react2.PropTypes.func
}, _temp)) || _class) || _class) || _class));

exports.default = TripDetail;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/TripDetail/TripDetail.js
// module id = 678
// module chunks = 0